import { TextField } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import axios from "axios";
import React, { useEffect } from "react";
import DatePicker from "react-date-picker";
import { useTranslation } from "react-i18next";
import { validateCryptoWallet } from "../../../../utils/attributesValidator";
import {
  ATTRIBUTES,
  EXCLUSION_HIDDEN_FIELDS,
  EXCLUSION_PAYMENT_SYSTEMS,
  EXCLUSION_SERVICES,
  OCT7,
  STANDARD_ERRORS_WAY
} from "../../../../utils/consts";
import { parseAxiosError } from "../../../../utils/response";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { StyledDatepicker } from "../../../styles/styledDatepicker";
import ConnectionsSelect from "../../connection/ConnectionsSelect";
import StablingCurrenciesSelect from "../../currencies/StablingCurrenciesSelect";
import InBodyFeeSelect from "../../inBodyFee/InBodyFeeSelect";
import IsStablingSelect from "../../isStabling/IsStablingSelect";
import MsCashAttributes from "../../msCash/MsCashAttributes";
import PageSpinner from "../../spinner/PageSpinner";
import InvoiceAttributeWithMask from "../attributes/InvoiceAttributeWithMask";

const InvoiceSecondStep = ({
  direction,
  invoiceData,
  setInvoiceData,
  setNotification,
  notification,
  errors,
  setErrors,
  handleClose
}) => {
  const { t } = useTranslation(["paymentsPage", "otherInterface"]);

  const dateLimits = {
    minDate: new Date("1900-01-01"),
    maxDate: new Date()
  };

  const getAttributes = () => {
    let data = {
      "paymentSystem": invoiceData.paymentSystem.subName,
      "currency": invoiceData.currency.asset,
      "service": invoiceData.service.name,
      "locale": "ru"
    };

    axios.get(
      "/api/transaction-attributes?currency.asset=" + data.currency + "&paymentSystem.subName=" + data.paymentSystem +
      "&service.name=" + data.service + "&transactionType=" + direction.slice(0, -1), userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setInvoiceData({ ...invoiceData, attributes: response.data["hydra:member"] });
      }
    }).catch(error => {
      handleClose();
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    getAttributes();
  }, []);

  if (!invoiceData.attributes) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  const renderMsCashAttributes = () => {
    return <>
      <MsCashAttributes
        invoiceData={invoiceData}
        setInvoiceData={setInvoiceData}
      />
    </>;
  };

  const validateAttributes = (data, attribute) => {
    let { value } = data.target;

    let regexp = new RegExp(attribute.regex.replace(/^.|.$/g, ""));

    switch (attribute.name) {
      case ATTRIBUTES.WALLET: {
        if (!validateCryptoWallet(invoiceData.currency.asset, value, invoiceData.paymentSystem.subName)) {
          setErrors({ ...errors, [attribute.name]: `Invalid wallet, example - ${attribute.placeholder}` });
        } else {
          delete errors[attribute.name];
          setErrors(prevState => ({ ...prevState }));
        }
      }
        break;
      default: {
        if (!regexp.test(value)) {
          setErrors({ ...errors, [attribute.name]: `Invalid ${attribute.title}, example - ${attribute.placeholder}` });
        } else {
          delete errors[attribute.name];
          setErrors(prevState => ({ ...prevState }));
        }
      }
    }
  };

  const renderExclusionHiddenAttributes = () => {
    if (
      !EXCLUSION_SERVICES.includes(invoiceData.service.name)
      || EXCLUSION_PAYMENT_SYSTEMS.includes(invoiceData.paymentSystem.subName)) {
      return;
    }

    return (invoiceData.attributes && invoiceData.attributes.map((value, key) => {
      if (!EXCLUSION_HIDDEN_FIELDS.includes(value.name)) {
        return;
      }

      return <TextField
        key={key}
        id={value.name}
        label={value.title}
        placeholder={value.placeholder}
        onChange={(data) => {
          const trimmedValue = data.target.value.trim();
          validateAttributes({ target: { value: trimmedValue } }, value);

          let values = [...invoiceData["attributes"]];
          values[key]["value"] = trimmedValue;
          setInvoiceData({ ...invoiceData, "attributes": values });
        }}
        error={errors[value.name] && true}
        helperText={errors[value.name] && errors[value.name]}
      />;
    }));
  };

  const renderAttributes = () => {
    return (
      invoiceData.attributes && invoiceData.attributes.map((value, key) => {
          switch (value.type) {

            case "input":
            case "date": {
              if (!invoiceData.service.name === OCT7) {
                return <TextField
                  key={key}
                  id={value.name}
                  label={value.title}
                  placeholder={value.placeholder}
                  // value={invoiceData["attributes"][value.id]}
                  onChange={(data) => {
                    const trimmedValue = data.target.value.trim();
                    validateAttributes({ target: { value: trimmedValue } }, value);

                    let values = [...invoiceData["attributes"]];
                    values[key]["value"] = trimmedValue;
                    setInvoiceData({ ...invoiceData, "attributes": values });
                  }}
                  error={errors[value.name] && true}
                  helperText={errors[value.name] && errors[value.name]}
                />;
              }

              switch (value.name) {
                case "cardNumber": {
                  return <InvoiceAttributeWithMask
                    mask="9999999999999999"
                    maskChar=""
                    onChange={(data) => {
                      const trimmedValue = data.target.value.replace(/\s/g, "");
                      validateAttributes({ target: { value: trimmedValue } }, value);

                      let values = [...invoiceData["attributes"]];
                      values[key]["value"] = data.target.value;
                      setInvoiceData({ ...invoiceData, "attributes": values });
                    }}
                    id={value.name}
                    label={value.title}
                    placeholder={value.placeholder}
                    error={errors[value.name] && true}
                    helperText={errors[value.name] && errors[value.name]}
                  />;
                  break;
                }

                case "phoneNumber": {
                  return <InvoiceAttributeWithMask
                    mask="+(999)999999999"
                    maskChar=""
                    onChange={(data) => {
                      const trimmedValue = data.target.value.replace(/\s/g, "");
                      validateAttributes({ target: { value: trimmedValue } }, value);

                      let values = [...invoiceData["attributes"]];
                      values[key]["value"] = data.target.value;
                      setInvoiceData({ ...invoiceData, "attributes": values });
                    }}
                    id={value.name}
                    label={value.title}
                    placeholder={value.placeholder}
                    error={errors[value.name] && true}
                    helperText={errors[value.name] && errors[value.name]}
                  />;
                  break;
                }

                case "cardExpire": {
                  return <InvoiceAttributeWithMask
                    mask="99/99"
                    maskChar=""
                    onChange={(data) => {
                      const trimmedValue = data.target.value.replace(/\s/g, "");
                      validateAttributes({ target: { value: trimmedValue } }, value);

                      let values = [...invoiceData["attributes"]];
                      values[key]["value"] = data.target.value;
                      setInvoiceData({ ...invoiceData, "attributes": values });
                    }}
                    id={value.name}
                    label={value.title}
                    placeholder={value.placeholder}
                    error={errors[value.name] && true}
                    helperText={errors[value.name] && errors[value.name]}
                  />;
                  break;
                }

                case "receiverBirthDate": {
                  return <StyledDatepicker error={errors[value.name] && true}>
                    <label htmlFor="dateFrom">
                      {value.title}
                    </label>
                    <DatePicker
                      format="yyyy-MM-dd"
                      id={value.name}
                      name={value.name}
                      className="date-input"
                      minDate={dateLimits.minDate}
                      maxDate={dateLimits.maxDate}
                      onChange={(data) => {
                        const offset = data.getTimezoneOffset();
                        data = new Date(data.getTime() - (offset * 60 * 1000));
                        const formattedDate = data ? data.toISOString().split("T")[0] : null;

                        validateAttributes({ target: { value: formattedDate } }, value);
                        let values = [...invoiceData["attributes"]];
                        values[key]["value"] = formattedDate;
                        setInvoiceData({ ...invoiceData, "attributes": values });
                      }}
                      value={[...invoiceData["attributes"]][key]["value"] ? new Date([...invoiceData["attributes"]][key]["value"]) : null}
                    />
                  </StyledDatepicker>;
                  break;
                }

                default: {
                  return <TextField
                    key={key}
                    id={value.name}
                    label={value.title}
                    placeholder={value.placeholder}
                    onChange={(data) => {
                      const trimmedValue = data.target.value.trim();
                      validateAttributes({ target: { value: trimmedValue } }, value);

                      let values = [...invoiceData["attributes"]];
                      values[key]["value"] = trimmedValue;
                      setInvoiceData({ ...invoiceData, "attributes": values });
                    }}
                    error={errors[value.name] && true}
                    helperText={errors[value.name] && errors[value.name]}
                  />;
                  break;
                }
              }
            }

            case "hidden": {
              switch (value.name) {

                case "isStabling": {
                  return <IsStablingSelect
                    checkedStablingOption={value.value}
                    setCheckedStablingOption={(data) => {
                      let values = [...invoiceData["attributes"]];
                      values[key]["value"] = data;
                      setInvoiceData({ ...invoiceData, "attributes": values });
                    }}
                  />;
                }

                case "inBodyFee": {

                  return <InBodyFeeSelect
                    checkedBodyFeeOption={value.value}
                    setCheckedBodyFeeOption={(data) => {
                      let values = [...invoiceData["attributes"]];
                      values[key]["value"] = data;
                      setInvoiceData({ ...invoiceData, "attributes": values });
                    }}
                  />;
                }

                case "stablingCurrency": {
                  if (!invoiceData.attributes.find(item => item.name === "isStabling" && item.value === "1")) {
                    break;
                  }

                  return <StablingCurrenciesSelect
                    checkedCurrencies={value.value}
                    setCheckedCurrencies={(data) => {
                      let values = [...invoiceData["attributes"]];
                      values[key]["value"] = data;
                      setInvoiceData({ ...invoiceData, "attributes": values });
                    }}
                  />;
                }
              }
            }
          }
        }
      )
    );
  };

  return (
    <>
        <Alert severity="info">
            <p>
                {t("project.title", {ns: "otherInterface"})}: {invoiceData.project?.name}
            </p>
            <p>
                {t("serviceReletionships.service", {ns: "otherInterface"})}: {invoiceData.service?.name}
            </p>
            <p>
                {t("serviceReletionships.currency", {ns: "otherInterface"})}: {invoiceData.currency?.asset}
            </p>
            <p>
                {t("serviceReletionships.paymentSystem", {ns: "otherInterface"})}: {invoiceData.paymentSystem?.name}
            </p>
            <p>
                {t("create.form.amount", {ns: "paymentsPage"})}: {invoiceData?.amount}
            </p>
            <p>
                {t("connection.name", {ns: "otherInterface"})}: {invoiceData.connection?.name}
            </p>
        </Alert>
      {
        (Object.keys(invoiceData.attributes).length === 0)
          ? <Alert severity="info">{t("create.form.attributes")}</Alert>
          :
          <>
            {renderAttributes()}
            {renderExclusionHiddenAttributes()}
            {renderMsCashAttributes()}
          </>
      }
      <TextField
        id="returnUrl"
        label="returnUrl"
        value={invoiceData.returnUrl}
        onChange={(data) => setInvoiceData({ ...invoiceData, "returnUrl": data.target.value })}
      />
      <TextField
        id="callBackUrl"
        label="callBackUrl"
        value={invoiceData.callBackUrl}
        onChange={(data) => setInvoiceData({ ...invoiceData, "callBackUrl": data.target.value })}
      />
      <TextField
        id="twofa"
        label={t("create.form.twoFa")}
        value={invoiceData.twofa}
        onChange={(data) => setInvoiceData({ ...invoiceData, "twofa": data.target.value })}
      />
    </>
  );
};

export default InvoiceSecondStep;